import React from "react";
import image14 from "../../image/we_are.jpg";

const HeroSection = () => {
  return (
    <div className="w-full relative min-h-[65vh] sm:min-h-[75vh] md:min-h-[85vh] flex items-center justify-center overflow-hidden bg-slate-950">

      {/* Immersive Main Background Image */}
      <img
        alt="PoloPipes Fluid Infrastructure Background"
        src={image14}
        className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none scale-105 transition-transform duration-1000"
      />

      {/* Modern Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/70 via-slate-950/50 to-slate-950/90 z-10"></div>

      {/* Decorative Ambient Radial Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-orange-500/20 rounded-full blur-[120px] pointer-events-none z-10"></div>

      {/* Top-right Catalogue Download - Enhanced Visibility */}
      <a
        href={`${process.env.PUBLIC_URL || ""}/catalogue/Catalogue.pdf`}
        download="PoloPipes-Catalogue.pdf"
        className="absolute top-6 right-6 sm:top-8 sm:right-8 md:top-12 md:right-16 z-30 inline-flex items-center gap-3 rounded-full border-2 border-orange-400 bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-3 sm:px-8 sm:py-4 text-sm sm:text-base font-bold text-white shadow-2xl shadow-orange-500/40 backdrop-blur-md transition-all duration-300 hover:-translate-y-1 hover:shadow-orange-500/60 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2 focus:ring-offset-slate-950 animate-pulse"
      >
        <svg
          className="h-5 w-5 sm:h-6 sm:w-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" />
        </svg>
        <span className="hidden sm:inline">Download Catalogue</span>
        <span className="sm:hidden">Catalogue</span>
      </a>

      {/* Hero Content Block */}
      <div className="relative z-20 max-w-5xl mx-auto px-6 text-center text-white pb-20 md:pb-28 pt-12 flex flex-col items-center">

        {/* Glassmorphic Floating Pill Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 shadow-lg mb-6">
          <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse"></span>
          <span className="text-orange-400 font-bold tracking-widest text-xs uppercase">
            Welcome to Polo Pipes
          </span>
        </div>

        {/* Main Heading with Gradient Accent */}
        <h1 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tight leading-none drop-shadow-2xl">
          Building <span className="bg-gradient-to-r from-orange-400 via-amber-300 to-orange-500 bg-clip-text text-transparent">fluid horizons</span>
        </h1>

        {/* Subtitle Line */}
        <p className="mt-6 text-slate-300 text-sm sm:text-base md:text-lg max-w-2xl font-normal leading-relaxed opacity-90 drop-shadow">
          Delivering high-performance certified polymer piping systems designed for endurance, fluid efficiency, and sustainable infrastructure.
        </p>

      </div>

      {/* Signature Curved SVG Bridge Accent */}
      <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-[0] z-20">
        <svg
          className="relative block w-full h-[60px] md:h-[120px]"
          viewBox="0 0 1920 120"
          preserveAspectRatio="none"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,120 C640,30 1280,30 1920,120 L1920,120 L0,120 Z"
            fill="#ffffff"
          />
        </svg>
      </div>

    </div>
  );
};

export default HeroSection;
